import { noop } from 'ramda-extension';

import { logout } from '@gef-ui/authorization/actions';
import { revokeDelegationCookies, revokeOriginalUserCookies } from '@gef-ui/delegations/utils';

import fetch from 'features/common/fetch';

export const beforeLogout = () => (dispatch) => {
	return dispatch(fetch.actions.deleteRequest(fetch.constants.urls.clearUsersCache)).then(() => {
		dispatch(logout(noop, true));
		revokeDelegationCookies();
		revokeOriginalUserCookies();
	});
};
